module.exports = __webpack_public_path__ + "img/image5.d522b778.png";